
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Teacher } from '@app/models/users'
import Headbar from '@app/components/shared/Headbar'

import { AbilityContext } from '@app/context/ability-context'
import { defineTeacherAbilities, authorize } from '@app/ability'
import NavigationTabs from '@app/components/shared/NavigationTabs'
import WarmUpBanner from "@app/components/shared/WarmUpBanner"

class TeacherLayout extends Component {
  render() {
    const Component = this.props.component
    const { teacher, route, global } = this.props
    const ability = defineTeacherAbilities(teacher, global)

    if (!authorize(ability, Component)) {
      return <Redirect to={`/404`} />
    }

    return (
      <div className="layout w-flex-layout layout--public" style={{ marginTop: '109px' }}>
        <Helmet>
          <title>{I18n.t('layouts.teacher.title')}</title>
        </Helmet>
        <AbilityContext.Provider value={ability}>
          <div className="w-flex-layout__top header-section__top">
            <Headbar
              global={global}
              user={teacher}
              route={route}
            />
            <NavigationTabs />
          </div>
          <div className="w-flex-layout__center">
            <WarmUpBanner event={global.event} />
            <Component teacher={teacher} route={route} global={global} />
          </div>
          <div className="w-flex-layout__bottom" />
        </AbilityContext.Provider>
      </div>
    )
  }
}

TeacherLayout.propTypes = {
  teacher: PropTypes.instanceOf(Teacher).isRequired,
  global: PropTypes.object.isRequired
}

export default TeacherLayout
